
import React, { useState } from 'react';
import { ImportantDate } from '../types';
import { PlusIcon } from './icons/PlusIcon';
import { TrashIcon } from './icons/TrashIcon';
import AddButtonPop from './AddButtonPop';

interface ImportantDatesProps {
    importantDates: ImportantDate[];
    onDelete: (id: string) => void;
    onOpenModal: () => void;
    isAdmin: boolean;
    onAdd?: (text: string, date: string) => void;
}

const ImportantDates: React.FC<ImportantDatesProps> = ({
    importantDates,
    onDelete,
    onOpenModal,
    isAdmin,
    onAdd
}) => {
    const [isAdding, setIsAdding] = useState(false);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Filter out past dates and sort by date
    const sortedDates = importantDates
        .filter(d => new Date(d.date.replace(/-/g, '/')) >= today) // Filter out past dates
        .sort((a, b) => new Date(a.date.replace(/-/g, '/')).getTime() - new Date(b.date.replace(/-/g, '/')).getTime());

    return (
        <div className="relative flex flex-col min-h-0">
            {isAdmin && (
                <AddButtonPop
                    isOpen={isAdding}
                    onClick={() => setIsAdding(!isAdding)}
                    onConfirm={(date, text) => {
                        if (onAdd) {
                            onAdd(text, date);
                        } else {
                            onOpenModal();
                        }
                    }}
                    isAdmin={isAdmin}
                    buttonText="Save Date"
                    titlePlaceholder="YYYY-MM-DD"
                    urlPlaceholder="Event Description"
                    input1Type="date"
                    input2Type="text"
                />
            )}

            <div className="flex-grow space-y-4 overflow-y-auto custom-scrollbar pr-2 mt-2">
                {sortedDates.length > 0 ? (
                    sortedDates.map((d) => (
                        <div key={d.id} className="group flex items-center bg-white/60 p-3 rounded-lg shadow-sm hover:shadow-md transition-all duration-200">
                            <div className="flex-shrink-0 text-center mr-3">
                                <p className="sidebar-date-month">{new Date(d.date.replace(/-/g, '/')).toLocaleDateString('ko-KR', { month: 'short' })}</p>
                                <p className="sidebar-date-day">{new Date(d.date.replace(/-/g, '/')).getDate()}</p>
                            </div>
                            <div className="truncate flex-1 min-w-0">
                                <p className="sidebar-item-link" title={d.text}>{d.text}</p>
                                <p className="sidebar-item-content">{new Date(d.date.replace(/-/g, '/')).toLocaleDateString('ko-KR', { weekday: 'long' })}</p>
                            </div>
                            {isAdmin && (
                                <button
                                    onClick={() => onDelete(d.id)}
                                    className="text-medium hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity ml-2"
                                    aria-label={`'${d.text}' 삭제`}
                                >
                                    <TrashIcon className="w-4 h-4" />
                                </button>
                            )}
                        </div>
                    ))
                ) : !isAdding && (
                    <div className="flex-grow flex items-center justify-center text-center text-medium">
                        <p>No important dates scheduled.</p>
                    </div>
                )}
            </div>

            {/* Removed bottom button */}

            {importantDates.length > 0 && sortedDates.length === 0 && (
                <p className="text-center text-sm text-medium py-2">남아있는 일정이 없습니다.</p>
            )}
        </div>
    );
};

export default ImportantDates;
